import Icon from "@/components/Icon";
import { Reveal } from "@/lib/motionSafe";
import { useSettings } from "@/lib/useSettings";

export default function QuoteCTA({ onOpenQuote, phone }) {
  const { settings } = useSettings();
  return (
    <section className="py-20 md:py-24 bg-[#050B14] relative overflow-hidden" data-testid="quote-cta">
      <div className="aman-glow-orb -bottom-32 -end-16 opacity-40" aria-hidden="true" />
      <div className="aman-glow-orb -top-32 start-1/4 opacity-30" aria-hidden="true" />

      <div className="max-w-5xl mx-auto px-6 md:px-10 relative text-center">
        <Reveal>
          <span className="aman-tag">جاهزون لخدمتك</span>
          <h2 className="font-heading mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
            {settings?.quote_cta_title_ar || "احصل على استشارة مجانية وعرض سعر خلال 24 ساعة"}
          </h2>
          <p className="mt-4 text-slate-300 max-w-2xl mx-auto leading-relaxed">
            {settings?.quote_cta_desc_ar || "سيقوم فريقنا الفني بدراسة موقعك واقتراح الحل الأنسب لميزانيتك واحتياجاتك دون أي التزام."}
          </p>
        </Reveal>
        <Reveal delay={160}>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
            <button
              onClick={onOpenQuote}
              className="aman-btn-primary text-base"
              data-testid="cta-quote-btn"
            >
              <Icon name="send" size={18} strokeWidth={2} />
              اطلب عرض سعر الآن
            </button>
            {phone && (
              <a
                href={`tel:${phone}`}
                className="aman-btn-secondary text-base"
                data-testid="cta-call-btn"
              >
                <Icon name="phone" size={18} />
                <span dir="ltr">{phone}</span>
              </a>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
